
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.Bought) {
  <div class="ticket_template_info_text ticket_template_info_text_status blue">
    {{ 'TICKET.IBA.STATUS.BOUGHT' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.MyClaimedTicket) {
  <div class="ticket_template_info_text ticket_template_info_text_status blue">
    {{ 'TICKET.IBA.STATUS.READY-FOR-DOWNLOAD' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.IdentificationRequired) {
  <div class="ticket_template_info_text ticket_template_info_text_status red">
    {{ 'TICKET.IBA.STATUS.IDENTIFICATION-REQUIRED' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.AssignmentRequired) {
  <div class="ticket_template_info_text ticket_template_info_text_status red">
    {{ 'TICKET.IBA.STATUS.ACTION-REQUIRED' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.InvitationPending) {
  <div class="ticket_template_info_text ticket_template_info_text_status orange">
    {{ 'TICKET.IBA.STATUS.EXPECTING-RESPONSE' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.InvitationRevoked) {
  <div class="ticket_template_info_text ticket_template_info_text_status green">
    {{ 'TICKET.IBA.STATUS.INVITATION-REVOKED' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.InvitationDeclined) {
  <div class="ticket_template_info_text ticket_template_info_text_status green">
    {{ 'TICKET.IBA.STATUS.INVITATION-DECLINED' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.Assigned) {
  <div class="ticket_template_info_text ticket_template_info_text_status green">
    {{ 'TICKET.IBA.STATUS.ACCEPTED' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.SecondaryMarketOnResale) {
  <div class="ticket_template_info_text ticket_template_info_text_status orange">
    {{ 'TICKET.IBA.STATUS.POSTED-FOR-EXCHANGE' | translate }}
  </div>
}
@if (ticket.TicketStatus.Status === MyTicketStatusEnum.SecondaryMarketSold) {
  <div class="ticket_template_info_text ticket_template_info_text_status green">
    {{ 'TICKET.IBA.STATUS.SOLD' | translate }}
  </div>
}
